import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export type Theme = 'dark-theme' | 'light-theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private defaultTheme: Theme = 'dark-theme';

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.initTheme();
  }

  private initTheme() {
    const savedTheme = localStorage.getItem('app-theme') as Theme;
    this.setTheme(savedTheme || this.defaultTheme);
  }

  setTheme(theme: Theme) {
    const body = document.body;
    body.style.background = '';
    body.classList.remove('dark-theme', 'light-theme');
    body.classList.add(theme);
    localStorage.setItem('app-theme', theme);
    this.setThemeColorMeta(theme);
  }

  setThemeColorMeta(theme: string): void {
    let color = "#fafafa";
    if (theme === 'dark-theme') {
      color = "#121212";
    }
    let metaTag = document.querySelector('meta[name="theme-color"]');
  
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', 'theme-color');
      document.head.appendChild(metaTag);
    }
  
    metaTag.setAttribute('content', color);
    metaTag.removeAttribute('media');
  }

  toggleTheme() {
    const currentTheme = localStorage.getItem('app-theme') as Theme;
    const nextTheme = currentTheme === 'dark-theme' ? 'light-theme' : 'dark-theme';
    this.setTheme(nextTheme);
  }

  getCurrentTheme(): Theme {
    return (localStorage.getItem('app-theme') as Theme) || this.defaultTheme;
  }
}
